// generated by recipeyak.api.base.codegen
import { http } from "@/apiClient"

export function calendarUpdateSettings(params: { syncEnabled: boolean }) {
  return http<{
    syncEnabled: boolean
    calendarLink: string
  }>({
    url: "/api/v1/calendar/settings/",
    method: "patch",
    params,
  })
}
